import { render } from "./DeletePhotosConfirmationModalComponent.vue?vue&type=template&id=1762479c&ts=true"
import script from "./DeletePhotosConfirmationModalComponent.vue?vue&type=script&lang=ts"
export * from "./DeletePhotosConfirmationModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__